import { useCookies } from "react-cookie";
import styled from "styled-components";

const Container = styled.div`
    text-align: center;
    margin: 10px 5px;
    border: 1px solid rgb(235, 226, 52);
    border-radius: 5px;
    padding: 10px;
`

type InformationMessageProps = {
    children: string
}

export const InformationMessage = ({ children }: InformationMessageProps) => {

    const [disabledInformationMessagesCookie, setDisabledInformationMessagesCookie, removeDisabledInformationMessagesCookie] = useCookies(['disabled_information_messages']);

    if (!disabledInformationMessagesCookie.disabled_information_messages) return <Container>{children}</Container>;
    return <></>;
}